import { defineRecipe } from '@chakra-ui/react'

export const progressRecipe = defineRecipe({
    variants: {
        variant: {
            gskWhite: {
                filledTrack: {
                    bgColor: 'dark.700',
                },
                track: {
                    bgColor: 'rgba(84, 79, 64, 0.08)',
                    transform: 'rotate(180deg)',
                },
            },
        },
    },
})
